export default {
  newMessage: new Audio(require('./new_message.ogg')),
  incomingChat: new Audio(require('./incoming_chat.mp3'))
};
